import { Lightning, Log } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';
import { RecordingHeader } from './components/RecordingHeader';
import { RecordingPageDataSource } from '../../../Business/recording/RecordingPageDataSource';
import { _constants } from '../../../components/MiniDetail';
import { CmsConstants } from '../../../Business/cms/CmsConstants';
import { ChannelManager } from '../../../api/ChannelManager';
import { SubscriptionTypes } from '../../../Business/detail/actions/epgRecordingActions/SubscriptionSettings.types';

const Constants = {
  header: {
    margin: {
      left: CmsConstants.Ribbon.pageContentOffset,
      top: 74,
    },
    height: 44,
  },
  content: {
    marginLeft: 98,
  },
};

export class RecordingPage extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      clipping: true,
      w: w => w,
      h: h => h,
      Container: {
        w: w => w,
        Header: {
          type: RecordingHeader,
          w: w => w - Constants.header.margin.left,
          h: Constants.header.height,
          y: Constants.header.margin.top,
          x: Constants.header.margin.left,
        },
        Content: {
          color: Theme.Colors.Transparent,
          flex: { direction: 'column' },
          w: w => w - Constants.content.marginLeft,
          y: Constants.header.margin.top + Constants.header.height + 10,
        },
      },
    };
  }

  _init() {
    /**
     * @type {Backend}
     */
    const backend = this.params.backend;
    const pageType = this.params.pageType || this.params.menuItem.pageType;
    this.pageDataSource = new RecordingPageDataSource(backend, pageType);
    this.reloadRecordingContent();
  }

  reloadRecordingContent() {
    const backend = this.params.backend;

    ChannelManager.channels(this.params.backend).then(channels => {
      this.pageDataSource.channels = channels;
      backend.cachedRecordingsApi.availableSpace(backend).then(values => this.tag('Header').setValues(values));
      this.pageDataSource.getRecordingContent().then(ds => {
        if (!ds) {
          return;
        }
        const content = this.tag('Content');
        content.childList.clear();
        content.childList.a({
          flexItem: { marginBottom: 20 },
          signals: { centerVertical: '_centerVertical' },
          w: this.finalW,
          contentOffset: CmsConstants.Ribbon.pageContentOffset,
          ...ds.componentDescription(),
        });
        this.focusIndex = content.childList.length > 0 ? 0 : -1;
        this._refocus();
      });
    });
  }

  _getFocused() {
    if (this.focusIndex !== -1) {
      return this.tag('Content').children[this.focusIndex];
    }
  }

  _centerVertical(centerY) {
    // Workaround for modals
    // Showing/hiding a modal will cause a refocus event, at which point this.finalH === 0
    // Prevent recentering in that case
    if (this.finalH === 0) return;

    let target = this.finalH / 2;

    if (this.tag('Content').children[this.focusIndex].data.cmsProperties) {
      if (!this.tag('Content').children[this.focusIndex].data.cmsProperties.includes('HIDE_MINI_DETAIL')) {
        target = (1080 - _constants.miniDetailHeight) / 2;
      }
    }

    const result = Math.min(
      0, //-this.tag('Content').finalH + this.tag('Content').finalH - constants.marginBottom,
      target - centerY
    );
    // console.log('centerVertical', centerY, target, result, this.tag('Content').finalH);

    this.tag('Container').setSmooth('y', result);
  }

  /**
   * TODO maybe merge recordingPage and RecordingFolderPage into one page?
   * @param cardEl {Lightning.Component}
   * @param type {SubscriptionTypes}
   */
  $removeEpgElement(cardEl, type) {
    /** @type {CmsGrid} */
    const grid = cardEl.cparent;
    if (grid?.cparent !== this) {
      Log.error(
        '[RecordingFolderPage]',
        'received remove call for card whose grid does not belong to this page, returning'
      );
      return;
    }
    if (type === SubscriptionTypes.PROGRAM) {
      // remove the one
      grid.removeCard(cardEl);
    }

    this.fireAncestors('$hideMiniDetail');
    this._refocus();
  }

  _active() {
    // this.reloadRecordingContent();
    this.pageDataSource.logPageView(this.params.backend, this.params.name);
  }

  _handleBack() {
    this.fireAncestors('$focusMenu');
    return true;
  }
}
